export { default } from '@/components/Maps/WebMapsScreen';
